<template>
  <div class="flex-fill d-flex justify-content-center">
    <div class="badge-container">
      <icon-container
        :iconClass="iconClass"/>
      <div class="badge-quantity">
        {{ quantity }}
      </div>
    </div>
  </div>
</template>

<script>
import IconContainer from "@/components/IconContainer.vue";

export default {
  name: "Badge",
  components: {
    IconContainer,
  },
  props: {
    quantity: {
      type: Number,
      default: 0,
    },
    iconClass: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.badge-container {
  position: relative;
  width: 62px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
}
.badge-quantity {
  width: 17px;
  height: 17px;
  border-radius: 50%;
  position: absolute;
  border: 1px solid $white-color;
  color: $white-color;
  font-size: 10px;
  right: 0;
  top: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
